/**
 * @ngdoc controller
 * @name SegmentController
 * @description Handles the segment views.
 * @param ecourse
 * @param EcourseFactory
 * @param $stateParams
 * @param $state
 * @param Ecourses - The ecourse Data service
 * @param Util
 * @param currentUser
 * @param $timeout
 * @param OverlayFactory
 * @param LiveService
 * @param environment
 * @param $sce
 * @param ViewsService
 * @param $q
 * @param $rootScope
 */
export default function segmentController($scope, ecourse, EcourseFactory, $stateParams, $timeout, $state, Ecourses, Util, currentUser, OverlayFactory, LiveService, environment, $sce, ViewsService, $q, $rootScope) {
  'ngInject';
  /**
   * @description An object to hold player event handlers so we can maipulate and turn them off.
   * @type {{}}
   */
  let playerEventHandlers = {};
  //Controller State
  //Segment live state
  this.live = false;
  //Media state
  this.selectedMedia = undefined;
  this.selectedMediaProgress = undefined;
  //Video player open/closed state.
  this.videoOpen = false;
  //Set a local -> reference to the ecourse resolved in the parent abstract state
  this.ecourse = ecourse;
  //Get the segment based on the URL
  this.segment = EcourseFactory.findSegment(ecourse, $stateParams.segment);
  //Segment porgress data
  this.segmentProgress = undefined;
  //The banner title duh!
  this.segmentBannerTitle = `${this.ecourse.speaker.name} | ${this.segment.title}`;
  //Not the best way of doing this, but we have segment background(for the overlay), a media background, and a ecourse background fallback
  this.background = undefined;
  this.hideGiftButton = true;
  //Live event actions
  //When the segment is live.
  if (this.ecourse.userData) {
    LiveService.live(this.segment).then(()=> {
      //Do this
      this.live = true;
      this.showChat = true;
      this.chatUrl = $sce.trustAsResourceUrl(`${environment.site.parent.replace('https', 'http')}/chat_window/${this.selectedMedia.guid}`);
    });

    LiveService.notLive(this.segment).then(()=> {
      //When the segment is transitioning from live to notLive
      this.showChat = false;
      if (this.livePlayerMessage) {
        this.live = false;
      }
    });
  }

  //Callables
  this.segmentAvailable = EcourseFactory.segmentAvailable.bind(EcourseFactory, this.segment);
  this.mediaAvailable = EcourseFactory.mediaAvailable.bind(EcourseFactory, this.segment);

  /**
   * @name play
   * @description Plays the media, adds the playing event handler for the progress system. Starts playback at last position.
   */
    //TODO - Due to player problems the starting playback at the last position is not working correctly.
  
  this.play = () => {
    
    Ecourses.getCurrentVideo(this.selectedMedia.livestream_id, false)
        .then(res => {
          const playerData = {
            playerPlaceholderDivId: "v1",
            videoManifestFilePath: res.livestreamVideoUrl,
          }
          const player = bethelPlayer(playerData);
          this.videoOpen = true;
        })
    
            
    
    // if (this.selectedMedia) {
    //   //Don't do anything if the current video is already complete
    //   if (this.selectedMediaProgress && !this.selectedMediaProgress.complete) {
    //     this.play(this.selectedMediaProgress.position);
    //   }
    //   else {
    //     this.play();
    //   }
    //   this.videoOpen = true;
    // }
  }

  this.pause = () => {
    jwplayer().remove();
  };

  /**
   * @description Return the completed status of a single media.
   * @param media
   * @returns {*}
   */
  
  this.mediaProgress = (media)=> {
    if (currentUser && ecourse.userData) {
      let {media: mediaProgress} = EcourseFactory.findProgress(this.ecourse, media.id);
      return mediaProgress;
    }
  };

  /**
   * @description set the media state to media selected
   * @param media
   */
  this.selectMedia = (media) => {
    this.videoOpen = false;
    this.selectedMedia = media;
    if (this.ecourse.userData) {
      //Get the progress for the current segment and media
      let {segment: segmentProgress, media: mediaProgress} =  EcourseFactory.findProgress(this.ecourse, this.selectedMedia.id);

      this.segmentProgress = segmentProgress;
      this.selectedMediaProgress = mediaProgress;
    }
    ViewsService.create('ecourse_media', this.selectedMedia.id);
  };
  
  /**
   * @description Select the media and play it if available.
   * @param media
   */
  this.playMedia = (media) => {
    if (this.mediaAvailable(this.segment) && this.ecourse.userData) {
      Util.scrollToTop();
      this.selectMedia(media);
      this.overlay = undefined;
      this.play();
    }
  };

  this.login = () => {
    Util.scrollToTop();
    $state.go('app.login');
  };

  /**
   * @description Handles the state params logic.
   */
  let init = () => {
    let media;
    
    //If the hidden state params request a media
    if ($stateParams.media) {
      media = EcourseFactory.findMediaInSegment(this.segment, parseInt($stateParams.media));
    }
    //No media requested, load the first media by default
    else {
      media = this.segment.mediaContent[0];
    }
    //Perhaps a segment may not contain any media. The template is setup with fall backs
    //If the media exists then select it.
    if (media) {
      this.selectMedia(media);
      this.mediaPlayable = this.mediaAvailable(this.segment);
      //If the hidden state params request auto-play then lets do it.
      if ($stateParams.play === true && this.mediaPlayable) {
        this.autoPlay = true;
      }
    }
  };

  //Sync progress with server every ten seconds.
  let progressSync = Util.throttle(()=> {
    Ecourses.syncProgress(this.ecourse);
  }, 10000);

  let uninstallPlayer = $rootScope.$on('playerReady', (player) => {

    if (!this.player) {
      this.player = player;
    }
    //Close video on media end.
    playerEventHandlers.end = this.player.on('OnMediaEnd', () => {
      //Unbind event
      playerEventHandlers.end();
      if (playerEventHandlers.progress) {
        playerEventHandlers.progress();
      }
      //Close Video
      this.videoOpen = false;
    });

    //Create a progress handler
    playerEventHandlers.progress = this.player.on('OnMediaPlaying', (event) => {
      //Get the max position in the video
      this.selectedMediaProgress.position = Math.max(this.selectedMediaProgress.position, event.data.mediaTime);
      //How much of the video is left
      let remainder = (event.data.duration - event.data.mediaTime);
      //If there is less than 5 seconds left in the video
      //TODO - ask if the stop time should be marked in the db so that different videos can have different completion time.
      if (remainder >= 0 && remainder <= 5000) {
        //Remove Event Handler - This turns the event handler off.
        playerEventHandlers.progress();
        //End playback
        this.player.pause();
        //Use progress if they arent complete, use video time if they are.
        if (!this.selectedMediaProgress.complete) {
          //Complete the media and if needed the progress
          EcourseFactory.complete(this.segmentProgress, this.selectedMediaProgress);
          Ecourses.syncProgress(this.ecourse);
        }
        if (this.live) {
          this.livePlayerMessage = this.segment.liveMessage ? this.segment.liveMessage : '';
          if(this.showChat === false){
            this.live = false;
            this.overlay = OverlayFactory.nextOverlay(this.ecourse, this.segmentProgress.complete, this.segment, this.selectedMedia);
          }
        }
        else {
          //Close video view.
          this.videoOpen = false;
          //Get the next overlay and set it
          this.overlay = OverlayFactory.nextOverlay(this.ecourse, this.segmentProgress.complete, this.segment, this.selectedMedia);
        }
      }
      else {
        //Call sync function
        progressSync(this.ecourse);
      }
    });

    if (this.autoPlay) {
      this.play();
    }
  });
  init();

  ViewsService.create('ecourse_segment', this.segment.id);

  let closeController = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
    if($state.is(fromState.name)) {
      Object.keys(playerEventHandlers).map(function (key) {
        playerEventHandlers[key]();
      });
      closeController();
      uninstallPlayer();
    }
  });
}



/** WEBPACK FOOTER **
 ** ./src/app/ecourse/segment/segment.controller.js
 **/